export default __webpack_public_path__ + "static/media/support-room-logo-light-final.57c07d02.png";